export const ListaRadnogVremenaGpsResourceBS: ListaRadnogVremenaGpsInterface = {
  title: "Lista Radnog Vremena sa GPS Lokacijom",
  errors: {
    query:
      "Došlo je do greške tokom učitavanja korisnika. Molimo kontaktirajte administratora.",
  },
  inputFields: {
    branch: {
      placeholder: "Odaberite poslovnicu",
      notFound: "Ni jedna poslovnica nije pronađena",
    },
    endDate: {
      label: "Krajnji datum",
    },
    startDate: {
      label: "Početni datum",
    },
  },
  pdf: {
    button: "Download PDF",
    document: {
      name: "Ime i prezime",
      title: "Evidencija radnog vremena sa GPS lokacijom",
      odabraniPeriod: "Odabrani period",
      potpisFooter: "Potpis",
      upisaoFooter: "Upisao",
      actionType: "Tip akcije",
      timestamp: "Vrijeme",
      gpsLocation: "GPS lokacija",
      potpisano: "Potpis",
      actionTypes: {
        START_WORK: "Početak rada",
        TAKE_BREAK: "Početak pauze",
        END_BREAK: "Kraj pauze",
        END_WORK_DAY: "Kraj radnog dana",
      },
    },
  },
};

export const ListaRadnogVremenaGpsResourceEN: ListaRadnogVremenaGpsInterface = {
  title: "Working Time List with GPS Location",
  errors: {
    query:
      "An error occurred while loading users. Please contact the administrator.",
  },
  inputFields: {
    branch: {
      placeholder: "Select branch",
      notFound: "No branch found",
    },
    endDate: {
      label: "End date",
    },
    startDate: {
      label: "Start date",
    },
  },
  pdf: {
    button: "Download PDF",
    document: {
      name: "Full name",
      title: "Working time evidence with GPS location",
      odabraniPeriod: "Selected period",
      potpisFooter: "Signature",
      upisaoFooter: "Entered by",
      actionType: "Action type",
      timestamp: "Timestamp",
      gpsLocation: "GPS location",
      potpisano: "Signature",
      actionTypes: {
        START_WORK: "Start work",
        TAKE_BREAK: "Take break",
        END_BREAK: "End break",
        END_WORK_DAY: "End work day",
      },
    },
  },
};

export const ListaRadnogVremenaGpsResourceDE: ListaRadnogVremenaGpsInterface = {
  title: "Arbeitszeitliste mit GPS-Standort",
  errors: {
    query:
      "Beim Laden der Benutzer ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
  },
  inputFields: {
    branch: {
      placeholder: "Filiale auswählen",
      notFound: "Keine Filiale gefunden",
    },
    endDate: {
      label: "Enddatum",
    },
    startDate: {
      label: "Startdatum",
    },
  },
  pdf: {
    button: "PDF herunterladen",
    document: {
      name: "Vollständiger Name",
      title: "Arbeitszeitnachweis mit GPS-Standort",
      odabraniPeriod: "Ausgewählter Zeitraum",
      potpisFooter: "Unterschrift",
      upisaoFooter: "Eingetragen von",
      actionType: "Aktionstyp",
      timestamp: "Zeitstempel",
      gpsLocation: "GPS-Standort",
      potpisano: "Unterschrift",
      actionTypes: {
        START_WORK: "Arbeitsbeginn",
        TAKE_BREAK: "Pausenbeginn",
        END_BREAK: "Pausenende",
        END_WORK_DAY: "Arbeitsende",
      },
    },
  },
};

export interface ListaRadnogVremenaGpsPDFInterface {
  name: string;
  title: string;
  odabraniPeriod: string;
  potpisFooter: string;
  upisaoFooter: string;
  actionType: string;
  timestamp: string;
  gpsLocation: string;
  potpisano: string;
  actionTypes: {
    START_WORK: string;
    TAKE_BREAK: string;
    END_BREAK: string;
    END_WORK_DAY: string;
  };
}

export interface ListaRadnogVremenaGpsInterface {
  title: string;
  errors: {
    query: string;
  };
  inputFields: {
    branch: {
      placeholder: string;
      notFound: string;
    };
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
  };
  pdf: {
    button: string;
    document: ListaRadnogVremenaGpsPDFInterface;
  };
}

